"use client";
import dynamicImport from "next/dynamic";
import type { PhoneInputProps } from "./PhoneInput";
import { validatePhone } from "./PhoneInput";


const LazyPhoneInputComponent = dynamicImport(() => import("./PhoneInput"));

export type LazyPhoneInputProps = PhoneInputProps;
export { validatePhone };

/**
 * A lazy-loaded phone input component with Romanian locale support.
 * Uses dynamic import to load PhoneInput only when needed.
 */
export default function LazyPhoneInput(props: LazyPhoneInputProps) {
  return <LazyPhoneInputComponent {...props} />;
}
